import { EventEmitter, Inject, Injectable, Output } from '@angular/core';
import { AppService } from '../app.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthProvider } from '../../enums/auth-provider';
import { UtilityFunctions } from '../../utilities/utility-functions';
import { UserSession } from '../../interfaces/user-session';

@Injectable({
    providedIn: 'root'
})

export class AuthService {

    private _apiBaseUrl: string = "";

    @Output() loggedIn = new EventEmitter<any>();
    @Output() loggedOut = new EventEmitter<boolean>();

    public constructor(public http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        this._apiBaseUrl = apiBaseUrl;
    }

    public exchangeCodeForToken = (fqdn: string, code: any, authProvider: AuthProvider): Observable<any> => {

        let result: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
        let apiPath: string = this.getAuthProviderTokenExchangeEndpointPath(authProvider);
        const fullPath: string = this._apiBaseUrl + apiPath;
        const httpOptions: any = { headers: new HttpHeaders({ "content-type": "application/json" }) };
        const request: any = { FQDN: fqdn, Code: code };

        this.http.post<boolean>(fullPath, request, httpOptions).subscribe((loginResult: any) => {

            result.next(loginResult);
            result.complete();

            this.loggedIn.emit(loginResult);

        }, error => {

            result.next(error);
        });

        return result;
    }

    private getAuthProviderTokenExchangeEndpointPath = (authProvider: AuthProvider): string => {

        let result = "";

        switch (authProvider) {

            case AuthProvider.Google:

                result = "auth/ExchangeGoogleCodeForToken";
                break;

            case AuthProvider.Instagram:

                result = "auth/ExchangeInstagramCodeForToken";
                break;
        }

        return result;
    }

    public isAuthenticated(): boolean {

        let result = false;

        var userSessionString: string = UtilityFunctions.getUserSession();

        if (userSessionString && userSessionString != "") {

            const userSession: UserSession = JSON.parse(userSessionString);

            result = userSession.sessionId != "";
        }

        return !!result;
    }
}
